import React from "react";
import "./OutsourceHero.css";

export default function OutsourceHero() {
  return (
    <div id="outsource-hero" className="outsourcemainclass">
      <div className="left">
        <h1>DevOps Automation Services</h1>
        <p>
          Accelerate software deployment and release cycles with intelligent
          DevOps automation. Minimize manual effort, enhance software quality,
          and streamline workflows and testing processes—empowering your teams
          to focus on productivity, innovation, and achieving critical business
          objectives.
        </p>
      </div>
    </div>
  );
}
